import './markdown-deck'

import { MarkdownDeck } from './markdown-deck'

export default MarkdownDeck
